// alterado - revisado

const tipoRegimeTributacaoList = [
    {
        id: 'P',
        descricao: 'Progressivo',
        ordem: 10,
    },
    {
        id: 'R',
        descricao: 'Regressivo',
        ordem: 20,
    },
]

export default tipoRegimeTributacaoList
